import React from "react";

export const SAF = [
  <>
    {/* <h4 className="slideTitle">A complete offer for all customer segments</h4> */}
    <div className="slideContainer slide_solidColour">
      <img
        src="images/SAF-image.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
  <div className="slideContainer slide_solidColour">
    <div className="">
      <h4 className="slideTitle">
        Achieving sectoral alignment in Aviation
      </h4>
      <p>
      Shell’s role in driving sectoral alignment
      </p>
      <ul className="shell_bullets_list icons_list">
        <li>
          <img
            src="images/airport-alignment-in-aviation-example.svg"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Lead by example</strong><br />Three-tiered approach – Avoid, Reduce, Offset
          </span>
        </li>
        <li>
          <img
            src="images/airport-alignment-in-aviation-business.svg"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Business</strong><br />SAF, offsets, developing new technologies 
          </span>
        </li>
        <li>
          <img
            src="images/airport-alignment-in-aviation-policy.svg"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Policy</strong><br />Advocating for government policy to increase supply of and demand for SAF
          </span>
        </li>
        <li>
          <img
            src="images/airport-alignment-in-aviation-global.svg"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Global consensus</strong><br />The Clean Skies for Tomorrow; WEF Mission Possible Platform; UK Sustainable Aviation coalition, UK Jet Zero Council, NL Synthetic SAF BHAG conference
          </span>
        </li>
      </ul>
    </div>
  </div>,
    <div className="slideContainer slide_solidColour">
    <div className="">
      <h4 className="slideTitle">
        Achieving sectoral alignment in Aviation
      </h4>
      <div class="d-flex split2x2">
        <p>
          <img
            alt=""
            src="images/SAF-neste.jpg"
            height="auto"
            width="auto"
          />
          Neste and Shell agreement to increase SAF supply
        </p>
        <p>
          <img
            alt=""
            src="images/SAF-development.jpg"
            height="auto"
            width="auto"
          />
          Developing and testing waste to fuel technology (iH₂*)
        </p>
        <p>
          <img
            alt=""
            src="images/SAF-amazon.jpg"
            height="auto"
            width="auto"
          />
          Supplying Amazon Air and DHL Express with SAF
        </p>
        <p>
          <img
            alt=""
            src="images/SAF-zeroavia.jpg"
            height="auto"
            width="auto"
          />
          Investment in ZeroAvia and Hydrogen flight
        </p>
      </div>
    </div>
  </div>,
];
